export async function jsonToYaml<T>(json: T): Promise<string> {
  const YAML = await import('yaml');
  return YAML.stringify(json);
}

export async function yamlToJson<T>(yaml: string): Promise<T> {
  const YAML = await import('yaml');
  return YAML.parse(yaml);
}
